/*
	Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
	SPDX-License-Identifier: MIT-0 
*/

/*
	Stores Cognito user pool ID and app client ID config info
	replace with your UserPoolId and ClientId values here
*/
const my_region = process.env.VUE_APP_AWS_REGION;
const my_domain_prefix = process.env.VUE_APP_AWS_COGNITO_DOMAIN_PREFIX;

export const awsAuthConfig = {
  region: my_region,
  userPoolId: process.env.VUE_APP_AWS_COGNITO_USER_POOL_ID,
  userPoolWebClientId: process.env.VUE_APP_AWS_COGNITO_USER_WEB_CLIENT_ID,
  oauth: {
    domain: `${my_domain_prefix}.auth.${my_region}.amazoncognito.com`,
    scope: ["openid"],
    // scope: ["aws.cognito.signin.user.admin", "openid"],
    redirectSignIn: process.env.VUE_APP_AWS_COGNITO_REDIRECT_URL,
    redirectSignOut: process.env.VUE_APP_AWS_COGNITO_REDIRECT_URL,
    responseType: "code",
  },
};
